export default __webpack_public_path__ + "static/media/component_5634555.befa9d2f.png";